/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListAIDetectionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Filter to detection targets of one category.
 */
export const Category = {
  Harness: "harness",
  Assistant: "assistant",
  LocalModel: "local_model",
} as const;
/**
 * Filter to detection targets of one category.
 */
export type Category = ClosedEnum<typeof Category>;

export type ListAIDetectionsRequest = {
  /**
   * Filter to detection targets of one category.
   */
  category?: Category | undefined;
  /**
   * Filter to detections attributed to active members of this SCIM directory group. A group with no active members yields an empty list.
   */
  directoryGroupId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAIDetectionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIDetectionsSecurity$outboundSchema: z.ZodMiniType<
  ListAIDetectionsSecurity$Outbound,
  ListAIDetectionsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAIDetectionsSecurityToJSON(
  listAIDetectionsSecurity: ListAIDetectionsSecurity,
): string {
  return JSON.stringify(
    ListAIDetectionsSecurity$outboundSchema.parse(listAIDetectionsSecurity),
  );
}

/** @internal */
export const Category$outboundSchema: z.ZodMiniEnum<typeof Category> = z.enum(
  Category,
);

/** @internal */
export type ListAIDetectionsRequest$Outbound = {
  category?: string | undefined;
  directory_group_id?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIDetectionsRequest$outboundSchema: z.ZodMiniType<
  ListAIDetectionsRequest$Outbound,
  ListAIDetectionsRequest
> = z.pipe(
  z.object({
    category: z.optional(Category$outboundSchema),
    directoryGroupId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      directoryGroupId: "directory_group_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAIDetectionsRequestToJSON(
  listAIDetectionsRequest: ListAIDetectionsRequest,
): string {
  return JSON.stringify(
    ListAIDetectionsRequest$outboundSchema.parse(listAIDetectionsRequest),
  );
}
